export function copyToClipboard(content) {
  var ele = document.createElement("input"); //创建一个input标签
  ele.setAttribute("value", content); // 设置改input的value值
  document.body.appendChild(ele); // 将input添加到body
  ele.select();  // 获取input的文本内容
  document.execCommand("copy"); // 执行copy指令
  document.body.removeChild(ele); // 删除input标签
}